import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Tooltip,
} from "@mui/material";

interface CardGlassProps {
  title: string;
  Icon: React.ElementType;
  color: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const CardGlass: React.FC<CardGlassProps> = ({
  title,
  Icon,
  color,
  value,
  onChange,
  placeholder = "Type here...",
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        backdropFilter: "blur(12px)",
        backgroundColor: "rgba(255, 255, 255, 0.4)",
        borderRadius: 4,
        p: 4,
        border: `1px solid ${color}33`,
        boxShadow: `0 6px 20px -6px ${color}2a`,
        transition: "transform 0.25s ease, box-shadow 0.25s ease",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: `0 14px 30px -6px ${color}55`,
          backgroundColor: "rgba(255, 255, 255, 0.55)",
        },
        height: 400,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box display="flex" alignItems="center" gap={2} mb={3}>
        <Tooltip title={title} arrow>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              background: `${color}20`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: `0 2px 8px ${color}25`,
              "&:hover": {
                backgroundColor: `${color}35`,
              },
            }}
            aria-hidden="true"
          >
            <Icon sx={{ fontSize: 30, color }} />
          </Box>
        </Tooltip>
        <Typography
          variant="h6"
          fontWeight={700}
          color="text.primary"
          sx={{ letterSpacing: "-0.02em" }}
        >
          {title}
        </Typography>
      </Box>

      <TextField
        multiline
        fullWidth
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        variant="outlined"
        sx={{
          flexGrow: 1,
          '& .MuiOutlinedInput-root': {
            height: '100%',
            alignItems: 'flex-start',
            '& textarea': {
              height: '100% !important',
              overflow: 'auto !important',
            },
          },
        }}
        inputProps={{
          style: {
            height: '100%',
            overflow: 'auto',
          },
        }}
      />
    </Paper>
  );
};

export default CardGlass;
